import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class GetRecordService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    ) { }

  getRecord(recordId: string, sectionId : string) {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    // this.storeAuth.getSection().subscribe((value) => {
    //   if (!value) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = value;
    //   }
    // });

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    //return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/record/${recordId}`, { headers: this.headers });
    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/recordWithData/${recordId}`, { headers: this.headers });
  }

}
